<template>
    <div class="alipay_success full">
        <div class="staus2" v-show="status == 1" style="height: 100%; position: relative;width: 100%;">
            <pay_success></pay_success>
        </div>
    </div>
</template>
<script>
    import pay_success from '@/components/pay_success/pay_success.vue';
    // import pay_fail from '@/components/pay_fail/pay_fail.vue';
    export default {
        data(){
            return {
                status: 1
            }
        },
        components: {
            pay_success
        }
    }
</script>

